import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2, AlertCircle } from "lucide-react";
import { validateSiret } from "@/lib/siret";

/** Champ SIRET avec contrôle immédiat (format + clé de Luhn) et message clair. */
export const SiretInput = ({ label = "SIRET (14 chiffres)", value, onChange, required, testid = "siret", labelClass = "text-[10px] uppercase tracking-[0.2em] font-semibold", inputClass = "h-10", hint }) => {
  const v = validateSiret(value);
  const tone = v.state === "valid" ? "text-[#059669]" : v.state === "invalid" ? "text-[#E60000]" : "text-[#868E96]";
  const border = v.state === "valid" ? "border-[#059669]" : v.state === "invalid" ? "border-[#E60000]" : "";
  return (
    <div className="space-y-1.5">
      <Label className={labelClass}>{label}{required && <span className="text-[#E60000]"> *</span>}</Label>
      <Input value={value} onChange={(e) => onChange(e.target.value)} required={required} inputMode="numeric" autoComplete="off"
             placeholder="732 829 320 00074" data-testid={testid} data-siret-state={v.state}
             aria-invalid={v.state === "invalid"} className={`${inputClass} font-mono ${border}`} />
      {(v.message || hint) && (
        <div className={`text-[11px] flex items-start gap-1 ${tone}`} data-testid={`${testid}-status`}>
          {v.state === "valid" && <CheckCircle2 className="h-3.5 w-3.5 mt-0.5 shrink-0" />}
          {v.state === "invalid" && <AlertCircle className="h-3.5 w-3.5 mt-0.5 shrink-0" />}
          <span>{v.message || hint}</span>
        </div>
      )}
    </div>
  );
};
